import { Assets } from "./assets.types";
import { PartnerConfig } from "../tenant.types";

import faviconIVI from "../../../assets/favicon-ivi.png";
import logoIVI from "../../../assets/logo.svg";
import confirmYourData from "../../../assets/confirmYourData/confirmYourData.svg";
import contact from "../../../assets/contact/contact.svg";
import contractOfAdhesion from "../../../assets/contractOfAdhesion/contractOfAdhesion.svg";
import contaDeLuz from "../../../assets/holder/conta-de-luz.svg";
import home from "../../../assets/home/home.svg";
import installation from "../../../assets/installation/installation.svg";
import selectYourDistributor from "../../../assets/selectYourDistributor/selectYourDistributor.svg";
import validation from "../../../assets/validation/validation.svg";
import checkIcon from "../../../assets/pdfErrorValidation/check.png";
import thunder from "../../../assets/UnapprovedAccount/flashEnergy.svg";
import logoBenup from "../../../assets/benup/logo-benup.svg";
import benupHome from "../../../assets/benup/home.svg";
import benupContact from "../../../assets/benup/contact.svg";
import benupValidation from "../../../assets/benup/validation.svg";
import benupHolder from "../../../assets/benup/holder.svg";
import benupInstallation from "../../../assets/benup/installation.svg";
import benupConfirmYourData from "../../../assets/benup/confirm-your-data.svg";
import benupContractOfAdhesion from "../../../assets/benup/contract-of-adhesion.svg";
import benupStatusCadastro from "../../../assets/benup/status-cadastro.svg";
import benupStatusBeneficios from "../../../assets/benup/status-beneficios.svg";
import benupStatusEconomia from "../../../assets/benup/status-economia.svg";

const DEFAULT_ASSETS: Assets = {
  favicon: faviconIVI,
  logo: {
    image: logoIVI,
    alt: "Logo da IVI",
  },
  confirmYourData: {
    image: confirmYourData,
    alt: "Confirme seus dados",
  },
  contact: {
    image: contact,
    alt: "Contato",
  },
  contractOfAdhesion: {
    image: contractOfAdhesion,
    alt: "Contrato de adesão",
  },

  holder: {
    image: contaDeLuz,
    alt: "Conta de luz",
  },
  holderPF: {
    image: contaDeLuz,
    alt: "Conta de luz",
  },
  holderPJ: {
    image: contaDeLuz,
    alt: "Conta de luz",
  },
  home: {
    image: home,
    alt: "Home",
  },
  installation: {
    image: installation,
    alt: "Instalação",
  },
  selectYourDistributor: {
    image: selectYourDistributor,
    alt: "Selecione sua distribuidora",
  },
  validation: {
    image: validation,
    alt: "Validação",
  },
  pdfErrorValidation: {
    image: checkIcon,
    alt: "Check icon",
  },
  weAreAlmostThere: {
    image: checkIcon,
    alt: "Check icon",
  },
  unapprovedAccount: {
    image: thunder,
    alt: "Thunder icon",
  },
  choosePlan: {
    image: home,
    alt: "Choose Plan",
  },
};

const BENUP_ASSETS: Assets = {
  ...DEFAULT_ASSETS,
  coBrand: {
    image: logoBenup,
    alt: "Logo da Benup",
  },
  statusIcons: {
    cadastro: { image: benupStatusCadastro, alt: "Aguardando validação do cadastro" },
    beneficios: { image: benupStatusBeneficios, alt: "Aguardando benefícios" },
    economia: { image: benupStatusEconomia, alt: "Economizando com a IVI" },
  },
  home: {
    image: benupHome,
    alt: "Home",
  },
  contact: {
    image: benupContact,
    alt: "Contato",
  },
  validation: {
    image: benupValidation,
    alt: "Validação",
  },
  holder: {
    image: benupHolder,
    alt: "Conta de luz",
  },
  holderPF: {
    image: benupHolder,
    alt: "Conta de luz",
  },
  holderPJ: {
    image: benupHolder,
    alt: "Conta de luz",
  },
  installation: {
    image: benupInstallation,
    alt: "Instalação",
  },
  confirmYourData: {
    image: benupConfirmYourData,
    alt: "Confirme seus dados",
  },
  contractOfAdhesion: {
    image: benupContractOfAdhesion,
    alt: "Contrato de adesão",
  },
};

const assets: Record<PartnerConfig, Assets> = {
  DEFAULT: DEFAULT_ASSETS,
  BENUP: BENUP_ASSETS,
};

export { assets };
